var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentLinkOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.93A5 5 0 0119.07 12l-1.06 1.06c.12-.85.022-1.725-.295-2.534a3 3 0 00-4.302-4.182l-2.828 2.828a3 3 0 00-.07 4.17l.07.073-1.415 1.414a5 5 0 010-7.071L12 4.929z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93 12l.989-.99a5.018 5.018 0 00.297 2.54 3 3 0 004.37 4.107l2.829-2.828a3 3 0 00-.828-4.83l1.464-1.463a5 5 0 01.778 7.707L12 19.071a5 5 0 01-7.07-7.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLinkOutline);
export default __webpack_public_path__ + "5f254139d9fcfdf08edcfb4098e73a1e.svg";
export { ForwardRef as ReactComponent };